import { api } from "@api/api";
import { Subscription } from "@modules/subscriptions/types";
import { SubscriptionFormValues } from "@modules/subscriptions/validations";

export async function createSubscriptionService(
  data: SubscriptionFormValues
): Promise<Subscription[]> {
  const plans = Array.isArray(data.plan) ? data.plan : [data.plan];

  return Promise.all(
    plans.map(async (plan) => {
      const { data: subscription } = await api.post<Subscription>(
        "v1/subscription_admin/",
        { ...data, plan }
      );

      return subscription;
    })
  );
}
